import { render, staticRenderFns } from "./form-campaign.vue?vue&type=template&id=5025ffd4&scoped=true&"
import script from "./form-campaign.vue?vue&type=script&lang=js&"
export * from "./form-campaign.vue?vue&type=script&lang=js&"
import style0 from "./form-campaign.vue?vue&type=style&index=0&id=5025ffd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5025ffd4",
  null
  
)

export default component.exports